import * as React from "react";
import AppBar from "@material-ui/core/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import MenuItem from "@material-ui/core/MenuItem";
import MenuIcon from "@material-ui/icons/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import { Link } from "react-router-dom";



import Menu from "@material-ui/core/Menu";

const pages = ["Home", "Plant","About"];
const settings = ["Profile", "Account", "Dashboard", "Logout"];

const ResponsiveAppBar = () => {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <AppBar style={{ "&:hover, &.Mui-focusVisible": { backgroundColor:"rgb(76 19 19 / 40%)" },}}
    
      elevation={4}
      position="sticky"
      style={{ backgroundColor: "rgb(76 19 19 / 30%)" }}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Typography
            variant="h4"
      
            component="div"
            sx={{ ml:1 , display: { xs: "none", md: "flex" } }}
          ></Typography>

          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: "block", md: "none" },
              }}
            >
              {pages.map((page) => (
                <MenuItem key={page} onClick={handleCloseNavMenu}>
                  <Typography variant="h3" color="blue" textAlign="center">
                    <Link to={`/${page}`}>{page}</Link>
                  </Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}
          >
            LOGO
          </Typography>
          <Box sx={{ flexGrow: 2,justifyContent: 'space-evenly',display: { xs: "none", md: "flex"  } }}>
            {pages.map((page) => (
              <Button
                key={page}
                onClick={handleCloseNavMenu}
                sx={{ my: 2, color: "yellow", display: "flex" ,border: 0 ,width: 100, }}
              >
                <Link
                style={{textDecoration:"none","&:hover, &.Mui-focusVisible": { backgroundColor:"rgb(76 19 19 / 40%)" }}}
               
                  to={`/${page}`}
                >
                <Typography   
                 style={{
                    
                  textDecoration:"none",
                  opacity: "0.9",
                  color: "white",
                  marginLeft: "20px",
                  fontSize:"20px",
                  fontFamily:"'Mouse Memoirs',sans-serif"
                }}>
                {page}

                </Typography>
                                </Link>
              </Button>
            ))}
          </Box>
                {/*settings icon*/}
          <Box sx={{ flexGrow: 0 }}>

          <Link onClick={()=>{localStorage.clear()}}
          style={{textDecoration:"none",color:"white",fontSize:"20px","&:hover, &.Mui-focusVisible": { backgroundColor:"rgb(76 19 19 / 40%)" },fontFamily:"'Mouse Memoirs',sans-serif"}}
         
            to={`/signin`}
          >
          LOGOUT
          </Link>
       
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};
export default ResponsiveAppBar;
